import { baseApi as api } from 'shared/api/baseApi';
const injectedRtkApi = api.injectEndpoints({
	endpoints: (build) => ({
		reportsBalanceTransactionsList: build.query<
			ReportsBalanceTransactionsListApiResponse,
			ReportsBalanceTransactionsListApiArg
		>({
			query: (queryArg) => ({
				url: `/api/reports/balance_transactions/`,
				params: {
					channel_id: queryArg.channelId,
					created_at_after: queryArg.createdAtAfter,
					created_at_before: queryArg.createdAtBefore,
					limit: queryArg.limit,
					offer_id: queryArg.offerId,
					offset: queryArg.offset,
					ordering: queryArg.ordering,
					reason: queryArg.reason,
					type: queryArg['type'],
				},
			}),
		}),
		withdrawalRequestList: build.query<WithdrawalRequestListApiResponse, WithdrawalRequestListApiArg>({
			query: (queryArg) => ({
				url: `/api/withdrawal_request/`,
				params: {
					created_after: queryArg.createdAfter,
					created_before: queryArg.createdBefore,
					limit: queryArg.limit,
					offset: queryArg.offset,
					ordering: queryArg.ordering,
				},
			}),
		}),
		withdrawalRequestCreate: build.mutation<WithdrawalRequestCreateApiResponse, WithdrawalRequestCreateApiArg>({
			query: () => ({ url: `/api/withdrawal_request/`, method: 'POST' }),
		}),
		withdrawalRequestRetrieve: build.query<WithdrawalRequestRetrieveApiResponse, WithdrawalRequestRetrieveApiArg>({
			query: (queryArg) => ({ url: `/api/withdrawal_request/${queryArg}/` }),
		}),
	}),
	overrideExisting: false,
});
export { injectedRtkApi as enhancedApi };
export type ReportsBalanceTransactionsListApiResponse = /** status 200  */ PaginatedBalanceTransactionListRead;
export type ReportsBalanceTransactionsListApiArg = {
	channelId?: string[];
	createdAtAfter?: string;
	createdAtBefore?: string;
	/** Number of results to return per page. */
	limit?: number;
	offerId?: string[];
	/** The initial index from which to return the results. */
	offset?: number;
	/** Which field to use when ordering the results. */
	ordering?: string;
	/** * `action` - ACTION
	 * `bonus` - BONUS
	 * `withdrawal` - WITHDRAWAL
	 * `adjustment` - ADJUSTMENT */
	reason?: ('action' | 'adjustment' | 'bonus' | 'withdrawal')[];
	/** * `replenishment` - replenishment
	 * `deduction` - deduction */
	type?: 'deduction' | 'replenishment';
};
export type WithdrawalRequestListApiResponse = /** status 200  */ PaginatedWithdrawalRequestListRead;
export type WithdrawalRequestListApiArg = {
	createdAfter?: string;
	createdBefore?: string;
	/** Number of results to return per page. */
	limit?: number;
	/** The initial index from which to return the results. */
	offset?: number;
	/** Which field to use when ordering the results. */
	ordering?: string;
};
export type WithdrawalRequestCreateApiResponse = /** status 201  */ WithdrawalRequestRead;
export type WithdrawalRequestCreateApiArg = void;
export type WithdrawalRequestRetrieveApiResponse = /** status 200  */ WithdrawalRequestRead;
export type WithdrawalRequestRetrieveApiArg = /** A UUID string identifying this transaction request. */ string;
export type BalanceTransaction = {
	currency: string;
	reason: ReasonEnum;
	created_at: string;
};
export type BalanceTransactionOffer = {
	name: string;
	image: string;
};
export type BalanceTransactionOfferRead = {
	uuid: string;
	name: string;
	image: string;
};
export type BalanceTransactionRead = {
	offer: BalanceTransactionOfferRead | null;
	currency: string;
	amount: string;
	reason: ReasonEnum;
	title: string | null;
	description: string | null;
	created_at: string;
	transferred_to_payment_system: boolean;
};
export type PaginatedBalanceTransactionList = {
	count: number;
	next?: string | null;
	previous?: string | null;
	results: BalanceTransaction[];
};
export type PaginatedBalanceTransactionListRead = {
	count: number;
	next?: string | null;
	previous?: string | null;
	results: BalanceTransactionRead[];
};
export type WithdrawalRequest = {};
export type WithdrawalRequestRead = {
	uuid: string;
	created_at: string;
	amount: string;
	status: WithdrawalRequestStatusEnum;
	payment_system_account_url: string | null;
};
export type PaginatedWithdrawalRequestList = {
	count: number;
	next?: string | null;
	previous?: string | null;
	results: WithdrawalRequest[];
};
export type PaginatedWithdrawalRequestListRead = {
	count: number;
	next?: string | null;
	previous?: string | null;
	results: WithdrawalRequestRead[];
};
export enum ReasonEnum {
	Action = 'action',
	Bonus = 'bonus',
	Withdrawal = 'withdrawal',
	Adjustment = 'adjustment',
}
export enum WithdrawalRequestStatusEnum {
	InProgress = 'in_progress',
	Success = 'success',
	Failed = 'failed',
}
